import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyAboutUs = _resolveComponent("CompanyAboutUs")!
  const _component_CompanyServices = _resolveComponent("CompanyServices")!
  const _component_CompanyTeam = _resolveComponent("CompanyTeam")!
  const _component_CompanyPartners = _resolveComponent("CompanyPartners")!
  const _component_CompanyPrinciples = _resolveComponent("CompanyPrinciples")!
  const _component_CompanyContact = _resolveComponent("CompanyContact")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CompanyAboutUs),
    _createVNode(_component_CompanyServices),
    _createVNode(_component_CompanyTeam),
    _createVNode(_component_CompanyPartners),
    _createVNode(_component_CompanyPrinciples),
    _createVNode(_component_CompanyContact)
  ]))
}